// *****************
// Component Created by - Vijay Navale
// Date - 05/10/2022
// Component use case:- To show products with it's categories
// *****************

import React, { useEffect, useState } from "react";
import { useWindowSize } from "react-use";
import "./catalogueCta.less";
import BannerItem from "../../component/BannerItem/BannerItem";
import bannerimg from "../../images/catalogue-cta/catalogue_banner.jpg";
import mbbannerimg from "../../images/catalogue-cta/mb_catalogue_banner_2.jpg";
// import catalogueFile from "../../images/catalogue-cta/New-Partner-Brands-Product-Catalogue.pdf";
import { ReactComponent as Downloadicon } from "../../images/catalogue/download-icon.svg";
import { Link } from "react-router-dom";
import http from "../../helpers/http";
import urldata from "../../urldata";
import config from "../../config/config";
import { request } from "../../helpers/axios-utils";

const ctaLists = [
  {
    id: 1,
    title: "HOS Brand Catalogue",
    link: "https://hosazurestorage.blob.core.windows.net/hos-beta/public/uploads/product/content/1765371795564Partner%20Brands%20Product%20Catalogue.pdf",
  },
  {
    id: 2,
    title: "Partner Brand Catalogue",
    link: "https://hosazurestorage.blob.core.windows.net/hos-beta/public/uploads/product/content/1765369897101HOS_INHOUSE_BRAND_CATALOGUE_2025_compressed.pdf",
  },
  {
    id: 3,
    title: "HOS Brand Catalogue",
    link: "https://hosazurestorage.blob.core.windows.net/hos-beta/public/uploads/product/content/1765371795564Partner%20Brands%20Product%20Catalogue.pdf",
  },
  {
    id: 4,
    title: "Partner Brand Catalogue",
    link: "https://hosazurestorage.blob.core.windows.net/hos-beta/public/uploads/product/content/1765369897101HOS_INHOUSE_BRAND_CATALOGUE_2025_compressed.pdf",
  },
  {
    id: 5,
    title: "Partner Brand Catalogue",
    link: "https://hosazurestorage.blob.core.windows.net/hos-beta/public/uploads/product/content/1765369897101HOS_INHOUSE_BRAND_CATALOGUE_2025_compressed.pdf",
  },
  {
    id: 6,
    title: "HOS Brand Catalogue",
    link: "https://hosazurestorage.blob.core.windows.net/hos-beta/public/uploads/product/content/1765371795564Partner%20Brands%20Product%20Catalogue.pdf",
  },
  {
    id: 7,
    title: "Partner Brand Catalogue",
    link: "https://hosazurestorage.blob.core.windows.net/hos-beta/public/uploads/product/content/1765369897101HOS_INHOUSE_BRAND_CATALOGUE_2025_compressed.pdf",
  },
];

const CatalogueCta = () => {
  const { width } = useWindowSize();
  const [catalog, setCatalog] = useState();
  const [catalogues, setCatalogues] = useState([]);
  const [catalogData, setCatalogueData] = useState();
  const azure_object_url =
    config.azure_object_url + "/public/uploads/product/content/";
  const azure_catalog_url =
    config.azure_object_url + "/public/uploads/catalog/";

  const fetchPartnerProductCatalogue = async () => {
    const { data } = await http.get(
      urldata + "partner-products/partner-product-catalog",
    );
    if (data) {
      setCatalog(data?.catalog);
      const catalogueRes = await fetchFeaturedProducts();
      setCatalogueData(catalogueRes?.data?.data?.catalog);
    }
  };

  const fetchCatalogues = async () => {
    const { data } = await http.get(urldata + "partner-products/catalog");

    if (data) {
      setCatalogues(data);
    }
  };

  const fetchFeaturedProducts = (offsetVal) => {
    return request({ url: `products?offset=0`, method: "get" });
  };

  useEffect(() => {
    fetchPartnerProductCatalogue();
    fetchCatalogues();
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
    document.title =
      "Explore the full catalogue of Laxmi (HOS) - North America's #1 South Asian Food Brand";
    document.getElementsByTagName("META")[3].content =
      "Checkout the full catalogue of Laxmi (HOS).The Laxmi Promise is to provide Purity, Quality and Value. Explore Laxmi's endless range of products now!";
    document.getElementsByTagName("META")[4].content =
      "Checkout the full catalogue of Laxmi (HOS).The Laxmi Promise is to provide Purity, Quality and Value. Explore Laxmi's endless range of products now!";
  }, []);

  return (
    <main className="main_catalog_sec1">
      <BannerItem
        color="black"
        img={bannerimg}
        imgMb={mbbannerimg}
        title="cAtalogUE"
      />

      {/* <section className="catalog_sec2">
        <div className="catasec2_heading">
          <div className="cta_wrapper">
            <a
              href={azure_object_url + catalogData}
              target="_blank"
              className="download_cta"
            >
              <span className="downloadtext">HOS Brand Catalogue</span>
              <Downloadicon className="downloadicon" />
            </a>
            <a
              href={`${azure_object_url}${catalog}`}
              target="_blank"
              className="download_cta"
            >
              <span className="downloadtext">Partner Brand Catalogue</span>
              <Downloadicon className="downloadicon" />
            </a>
          </div>
        </div>
      </section> */}

      <section className="catalog_sec3">
        <div className="catasec2_heading">
          <div className={`${catalogues?.length !== 0 ? "cta_grid" : "cta_grid_2"}`}>
            <div className="cta_col">
              <a
                href={azure_object_url + catalogData}
                target="_blank"
                className="download_cta"
              >
                <span className="downloadtext">HOS Brand Catalogue</span>
                <Downloadicon className="downloadicon" />
              </a>
            </div>
            <div className="cta_col">
              <a
                href={`${azure_object_url}${catalog}`}
                target="_blank"
                className="download_cta"
              >
                <span className="downloadtext">Partner Brand Catalogue</span>
                <Downloadicon className="downloadicon" />
              </a>
            </div>
            {catalogues?.map((item) => (
              <div className="cta_col" key={item._id}>
                <a
                  href={`${azure_catalog_url}${item.catelog}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download_cta"
                >
                  <span className="downloadtext">{item.name}</span>
                  <Downloadicon className="downloadicon" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default CatalogueCta;
